<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div [ngSwitch]="sideNavModeSignal()" class="secondary-side-panel-container">
  <div
    *ngIf="loiIdSignal() || submissionIdSignal()"
    class="secondary-side-panel"
  >
    <ng-container *ngSwitchCase="SideNavMode.SUBMISSION">
      <submission-panel
        *ngIf="submissionIdSignal()"
        [activeSurvey]="activeSurvey()"
        [selectedLoi]="selectedLoi()"
        [submissionId]="submissionIdSignal()"
      ></submission-panel>
    </ng-container>

    <ng-container *ngSwitchCase="SideNavMode.JOB_LIST">
      <ground-loi-panel
        *ngIf="loiIdSignal()"
        [activeSurvey]="activeSurvey()"
        [selectedLoi]="selectedLoi()"
      ></ground-loi-panel>
    </ng-container>
  </div>
</div>
